import safeLocalStorage from './safeLocalStorage';
export const FF_OVERRIDES_KEY = 'PUBLIC_DEBUG_FF_OVERRIDES';
export const COUNTRY_CODE_KEY = 'PUBLIC_DEBUG_COUNTRY_CODE';
export const BROWSER_LOCALE_KEY = 'PUBLIC_DEBUG_BROWSER_LOCALE';
export const I18N_LANG_KEY = 'PUBLIC_DEBUG_I18N_LANG';
function isRecordOfBooleans(value) {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false;
  }
  return Object.values(value).every(v => typeof v === 'boolean');
}
export function getFeatureFlagOverrides() {
  const raw = safeLocalStorage.getItem(FF_OVERRIDES_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    if (isRecordOfBooleans(parsed)) {
      return Object.assign({}, parsed);
    }
  } catch (_unused) {
    // corrupted value
  }
  return {};
}
export function applyFeatureFlagOverrides(flags) {
  const overrides = getFeatureFlagOverrides();
  const entries = Object.entries(overrides);
  if (entries.length === 0) return [...flags];
  const result = flags.filter(f => overrides[f] !== false);
  for (const [flag, enabled] of entries) {
    if (enabled && !result.includes(flag)) {
      result.push(flag);
    }
  }
  return result;
}
export function getCountryCodeOverride() {
  const val = safeLocalStorage.getItem(COUNTRY_CODE_KEY);
  return val ? val.toUpperCase() : null;
}
export function getBrowserLocaleOverride() {
  return safeLocalStorage.getItem(BROWSER_LOCALE_KEY);
}
export function getI18nLangOverride() {
  return safeLocalStorage.getItem(I18N_LANG_KEY);
}
export function getActiveOverrideCount() {
  let count = Object.keys(getFeatureFlagOverrides()).length;
  if (safeLocalStorage.getItem(COUNTRY_CODE_KEY)) count++;
  if (safeLocalStorage.getItem(BROWSER_LOCALE_KEY)) count++;
  if (safeLocalStorage.getItem(I18N_LANG_KEY)) count++;
  return count;
}